import React, { FC } from 'react'
import { Button } from 'uikit/buttons/default'
import styles from './ForbiddenAccessPage.module.scss'

const ivixLogoUrl = require('./images/ivix-logo.svg')

interface IForbiddenAccessPage {
    message: string
    onSubmit: () => void
}

const ForbiddenAccessPage: FC<IForbiddenAccessPage> = ({ message, onSubmit }) => {
  return (
    <div className={styles.container}>
        <div className={styles.header}>
          <img src={ivixLogoUrl} alt='IVIX' />
        </div>
        <div className={styles.content}>
            <header>
                Log In to IVIX
            </header>
            <div className={styles.message}>
                {message}
            </div>
            <footer>
                <Button type='primary' onClick={onSubmit}>Log Out</Button>
            </footer>
        </div>
      </div>
  )
}

export default ForbiddenAccessPage
